module.exports = __webpack_public_path__ + "static/img/7.a6a4b4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/7.png
// module id = dODQ
// module chunks = 0